function initStripe() {
  // Create and mount stripe elements form
  const stripe = Stripe(window.STRIPE_PUBLISHABLE_KEY); // eslint-disable-line no-undef
  const elements = stripe.elements({mode: 'payment',
                                    currency: 'usd',
                                    amount: 5000});
  const payment = elements.create("payment", {wallets: {applePay: 'never',
                                                        googlePay: 'never'}});

  payment.mount("#card-element");

  // Listen for changes and print errors if needed
  payment.addEventListener("change", ({ error }) => {
    const displayError = document.getElementById("card-errors");
    if (error) {
      displayError.textContent = error.message;
    } else {
      displayError.textContent = "";
    }
  });

  // Event listener for form submission to check if there are errors
  const form = document.getElementById("application-form");

  form.addEventListener("submit", async event => {
    event.preventDefault();

    const elementsSubmit = await elements.submit()

    const { confirmationToken, error } = await stripe.createConfirmationToken({elements});

    if (error) {
      const errorElement = document.getElementById("card-errors");
      errorElement.textContent = error.message;
    } else {
      const form = document.getElementById("application-form");
      const hiddenInput = document.getElementsByName("stripe_token")[0];
      hiddenInput.setAttribute("value", confirmationToken.id);
      form.submit();
    }
  });
}

window.initStripe = initStripe
// window.addEventListener("load", initStripe);
